import React, { useState } from "react";

const ScanWebsite = () => {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleScan = async () => {
    if (!url) {
      alert("Please enter a URL.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the website HTML.");
      }
      const htmlContent = await response.text();

      // Create a Blob from the HTML content
      const blob = new Blob([htmlContent], { type: "text/html" });
      const link = document.createElement("a");

      // Create a download link for the HTML file
      link.href = URL.createObjectURL(blob);
      link.download = `scan-${Date.now()}.html`; // Name the file with a timestamp
      link.click();
    } catch (err) {
        console.log(err)
      setError("Failed to fetch HTML content. Please check the URL.");
    } finally {
      setLoading(false);
    }
  };

  return (
    
    <div className="d-flex flex-column min-vh-100">
        <main className="flex-fill bg-light py-5">
      <h2 className="text-center mb-4">Scan Website</h2>

      {/* Error message */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Input for URL */}
      <div className="mb-3">
        <label htmlFor="url" className="form-label">
          Enter Website URL
        </label>
        <input
          type="url"
          id="url"
          className="form-control"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://example.com"
        />
      </div>

      {/* Scan Button */}
      <button
        onClick={handleScan}
        className="btn btn-primary w-100"
        disabled={loading}
      >
        {loading ? "Scanning..." : "Scan and Save HTML"}
      </button>
      </main>
    </div>
  );
};

export default ScanWebsite;

/* import React from "react";
import Header from "../Shared/Header";
import Footer from "../Shared/Footer";

const ScanWebsite = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userType = user?.type || "user"; // Default to "user"
  
    return (
      <div className="d-flex flex-column min-vh-100">
        <Header userType={userType} />
        <main className="flex-fill bg-light py-5">
          <div className="container">
            <div className="card shadow-sm p-4">
              <h1 className="card-title fs-3">
                Scan Website!
              </h1>
              <p className="card-text text-muted">
                Let your bot search the entire web or specific websites.
              </p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  };

export default ScanWebsite; */